

















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import Query from '../../../components/query/queryHeard.vue'
import {QueryMaterials,QuerySysDic} from '../../../api/material'
import {QueryManufacturer,CreateManufacturer,EditManufacturer} from '../../../api/basicDictionary'
import {QueryStockWarning} from '../../../api/storehouse'
import util from '../../../lib/util'
@Component({
  components:{myTable,Query}
})
export default class extends AbpBase{
    list:Array<object> = []
    addModalShow:boolean = false
    addModalData:object = null

    detailModalShow:boolean = false
    detailModalData:object = null
    //操作类型
    actionTypeOptions:any = [
        {value:1,text:'入库'},
        {value:2,text:'出库'},
        {value:3,text:'报损'},
        {value:4,text:'盘点'},
    ]
    conditions:any = []
    async created() {
        await this.getSelects()
        this.getData()   
    }
    itemTypeOptions:any = []
    //获取条件下拉框
    async getSelects(){
        this.itemTypeOptions = (await QuerySysDic({dataType:1,status:true,typeName:''})).data
        this.conditions = [
            {
                name:'itemType',
                dataType:6,
                value:this.itemTypeOptions[0].id,
                label:'物资类型',
                options:this.itemTypeOptions.map((item:any)=>{
                    return {
                        value:item.id,
                        text:item.typeName,
                    }
                })
            },
            {
                name:'materialName',
                dataType:1,
                value:null,
                label:'物资名称',
            },
            {
                name:'validityPeriodBegin',
                dataType:10,
                value:null,
                label:'有效期',
                valueFormat:'yyyy-MM-dd'
            },
        ]
    }
    async getData(){
        this.table.loading = true
        let search = {}
        this.conditions.forEach((item:any)=>{
            //日期区间特殊处理
            if(item.dataType===10){
                search['validityPeriodBegin'] = item.value?item.value[0]:''
                search['validityPeriodEnd'] = item.value?item.value[1]:''
            }else{
                search[item.name] = item.value
            }
        })
        let data = {
            ...this.table,
            ...search,
            pageType:1
        }
        let res = await QueryStockWarning(data)
        this.table.totalCount = res.data.totalCount;
        this.list = res.data.items;
        this.table.loading = false
    }
    pageChange(page:number){
        this.table.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.table.pageSize = pagesize
        this.getData();
    }
    columns:Array<object> = [
        {title:'物资类型',key:'itemTypeName'},
        {title:'物资编号',key:'materialCode'},
        {title:'物资类型',key:'itemTypeName'},
        {title:'物资名称',key:'materialName'},
        {title:'单位',key:'unitName'},
        {title:'库存',key:'quantity'},
        {title:'价格',key:'price'},
        {title:'批号',key:'batchNo'},
        {title:'库存警戒值',key:'stockWarn'},
    ]
}
